export const fontFamily = `'Montserrat', -apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"`;
export const headingFontFamily = `'Playfair Display', ${fontFamily}`;
